// FieldVision - NoteField.tsx
// Note textarea til mark-detalje siden

import React from 'react';

interface NoteFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  maxLength?: number;
}

const NoteField: React.FC<NoteFieldProps> = ({
  value,
  onChange,
  placeholder = 'Skriv en note til marken...',
  maxLength = 500
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange(e.target.value);
  };

  return (
    <div className="note-field">
      <textarea
        className="note-textarea"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        maxLength={maxLength}
        rows={3}
      />
      {maxLength && value.length > maxLength * 0.8 && (
        <span className="char-count">
          {value.length}/{maxLength}
        </span>
      )}

      <style>{`
        .note-field {
          position: relative;
        }

        .note-textarea {
          width: 100%;
          padding: 12px;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          font-size: 14px;
          font-family: inherit;
          resize: vertical;
          min-height: 80px;
          transition: border-color 0.2s, box-shadow 0.2s;
        }

        .note-textarea:focus {
          outline: none;
          border-color: #16a34a;
          box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.1);
        }

        .note-textarea::placeholder {
          color: #9ca3af;
        }

        .char-count {
          position: absolute;
          bottom: 8px;
          right: 12px;
          font-size: 11px;
          color: #9ca3af;
        }
      `}</style>
    </div>
  );
};

export default NoteField;
